import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCInput, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import DeleteModal from "src/components/DeleteModal";
import {IReportDeleteItem, IRefDeleteReportModal } from "./interface";
import {deleteSchema} from "./schemas";

const DeleteModalReport: React.ForwardRefRenderFunction<IRefDeleteReportModal> = (_,ref) => {
	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	const [onCloseFunction,setOnCloseFunction] = useState<(()=>void )>();
	
	const [reportDelete, setReportDelete] = useState<IReportDeleteItem>();

	// Modal Delete
	const modalDelete = useRef<RCCRefModalProps>(null);
	const { 
		handleSubmit: handleSubmitDelete, 
		register: registerDelete, 
		reset : resetDelete, 
		setError : setErrorDelete, 
		formState: { errors : errorsDelete }, 
		clearErrors: clearErrorsDelete 
	} = useForm();

	const actionButtonDelete = (row:IReportDeleteItem,onClose?:()=>void) => {
		resetDelete();
		setReportDelete(row);
		setOnCloseFunction(() => onClose);
		modalDelete.current?.openModal();
	};

	const submitDelete = async (data: any) => {
		try{
			clearErrorsDelete();
			modalDelete.current?.setLoadingButton();
			
			await deleteSchema(translate).validate({...data, "wda002TituloConfirmation": reportDelete?.wda002Titulo},{
				abortEarly: false
			});
			
			await RCCServicesApi.deleteRequest({
				method: "Reports/Delete",
				urlParameters: {
					wda002Id: reportDelete?.wda002Id
				}
			});

			addToast({
				color: "green",
				description: translate("Relatório excluído com sucesso" ),
				title: translate("Sucesso")
			});

			modalDelete.current?.resetLoadingButton();
			modalDelete.current?.closeModal();
			if(onCloseFunction)
				onCloseFunction();

		}catch(err){

			modalDelete.current?.resetLoadingButton();
			if(getValidationErrors(err, setErrorDelete))
				return;

			standardErrorMessages(err, translate("Erro ao excluir relatório"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		actionButtonDelete
	}));

	return (
		<DeleteModal
			ref={modalDelete}
			title= {translate("Exclusão de relatório")}
			description= {`${translate("Deseja realmente excluir o relatório")}: ${reportDelete?.wda002Titulo}?`}
			onSubmit = {handleSubmitDelete(submitDelete)}
			height="250px"
		>
			<RCCGrid
				container
				item
				xs={10}
			>
				<RCCInput 
					register={registerDelete}
					name="wda002Titulo"
					label={translate("Digite o nome do relatório para excluí-lo")}
					maxLength={200}
					error={errorsDelete.wda002Titulo}
					required
				/>
			</RCCGrid>
		</DeleteModal>
	);
};

export default forwardRef(DeleteModalReport);
